enum RemoteDataStatus {
  Initial = 'Initial',
  Loading = 'Loading',
  Done = 'Done',
  Error = 'Error',
}

export default RemoteDataStatus;
